// removed by extract-text-webpack-plugin
module.exports = {"UserPortalWrapper":"index__UserPortalWrapper___xTAjn"};


//////////////////
// WEBPACK FOOTER
// ./src/userportal/index.scss
// module id = ./src/userportal/index.scss
// module chunks = 1